import {canonicalizeSearchRequest} from '../../../utils/searchParamsUtils';
import {toURL} from '@homeaway/search-url-parser';

export const buildSeeAllLink = (searchParams, chosenFilter) => {
    const updatedInputParams = {
        ...searchParams.inputParams,
        filter: [...searchParams.inputParams.filter, chosenFilter]
    };
    const searchRequest = canonicalizeSearchRequest(updatedInputParams);

    return toURL(searchRequest);
};
